import { SiteSchema } from "../../models/site.schema";

export const PrivateSiteControllerResponseSchema = {
  getSite: SiteSchema.nullable(),

  updateSite: SiteSchema,
};
